import { axiosApi } from './index';
import { types, API_URL } from './types';

export const getFAQs = () => {
  const url = `${API_URL}/api/v1/faq`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.get(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setGetFAQs(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data.data;
        dispatch(setGetFAQs(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetFAQs({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetFAQs = (data) => ({
  type: types.faqGetFAQs,
  payload: data,
});

export const createFAQ = (categoria, pregunta, respuesta) => {
  const url = `${API_URL}/api/v1/faq/create`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .post(url, { categoria, pregunta, respuesta }, { validateStatus: false })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setCreateFAQ(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setCreateFAQ(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        outputData['message'] = 'Error al crear pregunta frecuente';
        dispatch(setCreateFAQ(outputData));
      });
  };
};

export const setCreateFAQ = (data) => ({
  type: types.faqCreateFAQ,
  payload: data,
});

export const updateFAQ = (faqId, categoria, pregunta, respuesta) => {
  const url = `${API_URL}/api/v1/faq/edit/${faqId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi
      .put(url, { categoria, pregunta, respuesta }, { validateStatus: false })
      .then(({ data }) => {
        if (data.error) {
          outputData['status'] = 'danger';
          outputData['message'] = data.message;
          dispatch(setUpdateFAQ(outputData));
        } else {
          outputData['status'] = 'success';
          outputData['message'] = data.message;
          outputData['data'] = data.data;
          dispatch(setUpdateFAQ(outputData));
        }
      })
      .catch((error) => {
        outputData['status'] = 'danger';
        outputData['message'] = 'Error al actualizar pregunta frecuente';
        dispatch(setUpdateFAQ(outputData));
      });
  };
};

export const setUpdateFAQ = (data) => ({
  type: types.faqUpdateFAQ,
  payload: data,
});

export const deleteFAQById = (faqId) => {
  const url = `${API_URL}/api/v1/faq/${faqId}`;
  return (dispatch) => {
    let outputData = {};
    axiosApi.delete(url, { validateStatus: false }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setDeleteFAQById(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        outputData['data'] = data;
        outputData['faqId'] = faqId;
        dispatch(setDeleteFAQById(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setDeleteFAQById({ status: 'danger', error: true, message }));
      });
  };
};

export const setDeleteFAQById = (data) => ({
  type: types.faqDeleteFAQById,
  payload: data,
});
